import { render, staticRenderFns } from "./FollowUpOrderTypeForm.vue?vue&type=template&id=ed9d181e&"
import script from "./FollowUpOrderTypeForm.vue?vue&type=script&lang=js&"
export * from "./FollowUpOrderTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports